export default __webpack_public_path__ + "0151aa663c80db03abf579086530c062.png";